const FirstExperienceStatus = Object.freeze({
  Idle: '0',
  DoneBigBanner: '1',
  DoneSmallBanner: '2',
});

export default FirstExperienceStatus;
